// extracted by mini-css-extract-plugin
export default {"container":"RoundedButton_container__CKtNe","button":"RoundedButton_button__MdT1U","textArea":"RoundedButton_textArea__-TQzi","iconArea":"RoundedButton_iconArea__bV8ZN"};